import { render, staticRenderFns } from "./EmployeesHistory.vue?vue&type=template&id=e117d524"
import script from "./EmployeesHistory.vue?vue&type=script&lang=js"
export * from "./EmployeesHistory.vue?vue&type=script&lang=js"
import style0 from "./EmployeesHistory.vue?vue&type=style&index=0&id=e117d524&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports